export const art = `
####       ####   #### ##  #### ##  ####     ### ###           ### ###    ####   ####     ####      ## ##   
 ##         ##    # ## ##  # ## ##   ##       ##  ##            ##  ##     ##     ##       ##      ##   ##  
 ##         ##      ##       ##      ##       ##                ##         ##     ##       ##      ####     
 ##         ##      ##       ##      ##       ## ##             ## ##      ##     ##       ##       #####   
 ##         ##      ##       ##      ##       ##                ##         ##     ##       ##          ###  
 ##  ##     ##      ##       ##      ##  ##   ##  ##            ##         ##     ##  ##   ##  ##  ##   ##  
### ###    ####    ####     ####    ### ###  ### ###           ####       ####   ### ###  ### ###   ## ##   `;
